import { makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import Ambiente from '../util/Ambiente';
import ReactComponent from './ReactComponent';

class TelaVersao extends ReactComponent {
    informacoesApp = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            informacoesApp: observable
        });
    }

    async componentDidMount() {
        try {
            if (!Ambiente.isAmbienteInicializado()) {
                await Ambiente.esperarInicializacaoAmbiente();
            }

            let variaveisAmbiente = await this.healthCheckService.carregaVariaveisAmbiente();
            runInAction(() => {
                this.informacoesApp = variaveisAmbiente;
            });
        } catch (error) {
            console.error(`Falha na inicialização do componente TelaVersao: ${ErrorUtil.montarMensagemErro(error)}`);
            throw new Error('Falha na inicialização do componente TelaVersao.');
        }
    }

    render() {
        return (
            <div style={{ backgroundColor: '#346785', width: '100%', height: '100%' }}>
                <div
                    style={{
                        margin: 'auto',
                        backgroundColor: '#FFF',
                        maxHeight: '100px',
                        maxWidth: '380px',
                        position: 'fixed',
                        top: '0',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        textAlign: 'center',
                        borderRadius: '5px',
                        lineHeight: '100%'
                    }}
                >
                    <h3 style={{ fontSize: '20px', color: '#706D6E', lineHeight: '50%' }}>Secretaria Eletrônica</h3>
                    <h3 style={{ color: '#706D6E', lineHeight: '50%', fontSize: '15px' }}>
                        Versão: {this.informacoesApp.versaoAplicacao}
                    </h3>
                    <h3 style={{ color: '#706D6E', lineHeight: '50%', fontSize: '15px' }}>
                        Build: {this.informacoesApp.dataBuild}
                    </h3>
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(TelaVersao));
